import {
  TrainingClientProviderStatusDto,
  UserDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const trainingAdminRequests = {
  getTrainingCharacters: new EndpointDefinition<UserDto[], null, null>({
    name: 'getTrainingCharacters',
    route: '/users/training-characters',
    method: 'GET',
  }),

  resetTrainingCharacters: new EndpointDefinition<UserDto[], null, null>({
    name: 'resetTrainingCharacters',
    route: '/users/reset-training-characters',
    method: 'POST',
  }),

  getTrainingProviderStatus: new EndpointDefinition<
    TrainingClientProviderStatusDto,
    null,
    null
  >({
    name: 'getTrainingClientProviderStatus',
    route: '/clients/training-provider-status',
    method: 'GET',
  }),

  setTrainingProviderStatus: new EndpointDefinition<
    TrainingClientProviderStatusDto,
    TrainingClientProviderStatusDto,
    null
  >({
    name: 'updateTrainingClientProviderStatus',
    route: '/clients/training-provider-status',
    method: 'POST',
  }),
};
